import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { SDKProvider } from "./services/sdk.service.js";
import { initSession } from "./services/session.service.js";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing from index.html");

/**
 * Render immediately in the "loading" state, then let `initSession` flip it. Awaiting the session
 * before the first paint would leave a blank white page for the duration of the restore round trip.
 *
 * `initSession` handles its own failures by ending the session, so a rejection here would be a bug
 * rather than an expected path — surface it in the console instead of swallowing it.
 */
createRoot(container).render(
  <StrictMode>
    <SDKProvider>
      <App />
    </SDKProvider>
  </StrictMode>,
);

initSession().catch((e) => console.error("Session init failed", e));
